<template>
    <div style="position: relative;">
        <b-navbar type="light" toggleable="sm" class="shadow-sm module-navbar">
            <!-- b-navbar-toggle is the burger menu for b-collapse when it is collapsed -->
            <b-navbar-toggle target="nav_dropdown_collapse"></b-navbar-toggle>
            <!-- Collapsible menu -->
            <b-collapse id="nav_dropdown_collapse" is-nav>
                <b-navbar-nav>
                    <b-nav-item>
                        Example Link
                    </b-nav-item>
                    <b-nav-item disabled>
                        <!-- Usually use the text "Saving..." -->
                        <i class="cus-hourglass"></i>Example Loading...
                    </b-nav-item>
                </b-navbar-nav>
            </b-collapse>
            <!-- For right nav, not collapsible -->
            <b-navbar-nav class="ml-auto">
                <b-nav-item href>
                    Example Right Nav
                </b-nav-item>
            </b-navbar-nav>
        </b-navbar>

        <router-view></router-view>
    </div>
</template>
<script>
export default {
    components: {},
    data() {
        return {
            resources: {},
            searchContactKey: 0,
            isLoading: false
        };
    },
    computed: {},
    created() {},
    mounted() {},
    methods: {}
};
</script>
